var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed left-0 bottom-0 bg-white w-full border-t-2 border-gray-200 z-50"},[_c('div',{staticClass:"flex justify-between items-start m-auto p-3 w-full max-w-4xl md:px-6 lg:px-8"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }